module.exports = __webpack_public_path__ + "static/data-analytics-1-b988dbac4721499aafd3d6f68247e40a.svg";